import * as React from 'react';
import { Html } from '../../helpers/html-helpers';

interface IFilterPageHeaderProps {
    title: string;
    message: string;
}

class FilterPageHeader extends React.PureComponent<IFilterPageHeaderProps, any>{
    render() {
        const { title, message } = this.props;

        return (
            <section className="filters-section">
                <div className="filters-section-heading contains-btn">
                    <h2 className="heading-general">{title}</h2>
                </div>
                {Html.renderParagraph(message, "caption-paragraph")}
            </section>
        );
    }
}

export default FilterPageHeader;